import React, { useContext, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { Transition } from 'react-spring/renderprops';
import { withTranslation, Trans } from 'react-i18next';
import {Link, Redirect, useSearchParams} from "react-router-dom";
import OutlookWizard from './OutlookWizard';
import OrElement from "./OrElement";

function OutlookComponent(props) {
  const userContext = useContext(UserContext)

  const emailError = (userContext.errors != null && userContext.errors.email != null);
  const inputClassName = emailError ? 'form-control is-invalid' : 'form-control';
  const formClassName = userContext.errors != null ? '' : 'was-validated';

  const inOutlook = true;
  const outlookEmail = Office.context.mailbox.userProfile.emailAddress

  const storedUseOutlookEmail = Office.context.roamingSettings.get('use_outlook_email')
  const shouldUseOutlookEmail = storedUseOutlookEmail === false ? false : (outlookEmail && !emailError) ? true : false

  // uncomment to test
  Office.context.roamingSettings.set('use_outlook_email', null);
  Office.context.roamingSettings.saveAsync(function(result) {})
  //

  const [email, setEmail] = useState(userContext.user.email);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [emailStatus, setEmailStatus] = useState(true);
  const [outlookSigninErrors, setOutlookSigninErrors] = useState(false)
  const [useOutlookEmail, setUseOutlookEmail] = useState(shouldUseOutlookEmail);

  //user confirmed outlook email
  if (outlookEmail && storedUseOutlookEmail === true){
    userContext.checkUserEmail(outlookEmail, inOutlook, null)
    return
  }

  //user did not confirm use of outlook email, but it is present
  if (!email && useOutlookEmail){
    setEmail(outlookEmail)
  } else {
    //user denied useOutlookEmail or outlookEmail is not present
  }

  const title = useOutlookEmail ? 'Connect with your MS Office account' : 'Sign in using your Officebooking account'
  const signInText = useOutlookEmail ? 'Use SSO to sign in' : 'Use your email to sign in';
  const text = ''

  Office.context.roamingSettings.set('outlook_token', '');
  Office.context.roamingSettings.saveAsync(function(result) {})

  const handleUseOutlookEmail = () => {
    setUseOutlookEmail(true)
    Office.context.roamingSettings.set('use_outlook_email', true);
    Office.context.roamingSettings.saveAsync(function(result) {})
  }

  const handleDoNotUseOutlookEmail = () => {
    setUseOutlookEmail(false)
    Office.context.roamingSettings.set('use_outlook_email', false);
    Office.context.roamingSettings.saveAsync(function(result) {})
    setEmail('')
  }

  const handleOutlookSignIn = (event) =>{
    event.preventDefault();
    event.stopPropagation();
    // var token = OfficeRuntime.auth.getAccessToken({
    //   allowConsentPrompt: true,
    //   allowSignInPrompt: true
    // }).then(token => {
    //   debugger
    // }).catch((ex) => {
    //   debugger
    // });
    const accessToken = Office.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true,
    }).then(token => {
      userContext.checkUserEmail(outlookEmail, inOutlook, token)
    }).catch((ex)=>{
      setOutlookSigninErrors(true)
      // userContext.checkUserEmail(outlookEmail, inOutlook, 'jlksdjfsdlkfjewiojwof')
    });
  }

  return (
    <>
      <ContentCard title={<Trans i18nKey={title} />} text={<Trans i18nKey={text} />}>
        <div className="">
          <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />

          {loadingStatus &&
            <div className="d-flex justify-content-center mt-3">
              <div className="spinner-border" role="status">
                <span className="visually-hidden"><Trans i18nKey="loading" />...</span>
              </div>
            </div>
          }

          {outlookEmail &&
            <>
              
              {/* <small>{outlookEmail}</small> */}
              <button onClick={handleOutlookSignIn} className="btn btn-secondary btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                <Trans i18nKey="sign_in_outlook"/>
              </button>
              {outlookSigninErrors &&
                <div className="error"><Trans i18nKey="error_generic"/></div>
              }
              <div className="col-9 mx-auto"><OrElement /></div>
            </>
          }

          <h1 className="mt-4">{signInText}</h1>
          <form className={formClassName}
                onSubmit={(event)=> {
                  event.preventDefault()
                  event.stopPropagation()
                  userContext.checkUserEmail(email, inOutlook, null)
                }}>
            <div className="form-floating my-3" style={props} >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled = {useOutlookEmail}
                className={inputClassName}
                id="emailInput"
                placeholder="name@example.com" />
              <label htmlFor="emailInput"><Trans i18nKey="email_address" /></label>
              {emailError &&
                <div className="invalid-feedback">
                  {userContext.errors.email.map((error) => (
                    <span key={error}><Trans i18nKey="email" /> {error}</span>
                  ))}
                </div>
              }
            </div>
            {useOutlookEmail ? (
              <>
                <button onClick={handleUseOutlookEmail} className="btn btn-secondary btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                  <Trans i18nKey="sign_in" />
                </button>
                <div className="col-9 mx-auto"><OrElement /></div>
                <button onClick={handleDoNotUseOutlookEmail} className="btn btn-link btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                  <Trans i18nKey="sign_in_with_password" />
                </button>
              </>
              ) : (
              <button className="btn btn-primary btn-lg mt-4 mb-3 px-5 w-100" type="submit">
                <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="sign_in" />
              </button>
              )}
          </form>
        </div>
      </ContentCard>
      <OutlookWizard />
    </>
  );
}

export default withTranslation()(OutlookComponent);
